exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".relations-network[data-v-c6940e2a] {\n  height: 100%;\n  position: relative;\n  background-color: #fff;\n}\n.relations-network_fullscreen[data-v-c6940e2a] {\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    z-index: 123;\n}\n.relations-network .afil-legend.fullscreen[data-v-c6940e2a] {\n    bottom: 15px;\n    right: 15px;\n}\n#relations-search-scheme[data-v-c6940e2a] {\n  width: 100%;\n  height: 100%;\n  min-height: 500px;\n  margin: 0 auto;\n}\n", ""]);

// exports
